<script lang="ts">
import { onMount } from 'svelte'

import type { AppLocale } from '@/modules/translations'
import { locale } from '@/modules/translations'
import { differenceInMilliseconds, formatRelativeTime } from '@/utils/date'
import { getHostWindow } from '@/utils/window'

type Props = {
	date: string
}

let { date }: Props = $props()

const DEFAULT_INTERVAL = 60 * 1000

let interval: number | undefined
let formattedTime: string = $state('')

const getRelativeTime = (d: string, locale: AppLocale) => {
	const elapsedTimeInMs = differenceInMilliseconds(new Date(d), new Date())
	return formatRelativeTime(elapsedTimeInMs, locale)
}

onMount(() => {
	interval = getHostWindow().setInterval(() => {
		formattedTime = getRelativeTime(date, $locale)
	}, DEFAULT_INTERVAL)

	return () => {
		interval && getHostWindow().clearInterval(interval)
	}
})

$effect(() => {
	formattedTime = getRelativeTime(date, $locale)
})
</script>

{formattedTime}
